export default __webpack_public_path__ + "static/media/IMG_8534.0aee1783.JPG";